import React from "react";
import CONFIG from "../../../../config";
import { ID_TEST_A_APK, ID_TEST_A_GOOGLE, ID_TEST_A_RUSTORE } from "../../../../spec/config";

import baibolLogo from '../../../../assets/img/where-pay/baibol-logo.svg';
import ruStoreLogo from '../../../../assets/img/where-pay/ru-store.svg';
import googleLogo from '../../../../assets/img/where-pay/google.svg';
import apkLogo from '../../../../assets/img/where-pay/apk-baibol-logo.svg';
import apkText from '../../../../assets/img/where-pay/apk-baibol-text.svg';

const { LINKS } = CONFIG;

const BaibolItem: React.FC = () => (
    <div className="where__pay__item red">
        <div className="where__pay__title">
            <img src={baibolLogo} alt="ООО МКК ”Байбол”" />
            <span>ООО МКК ”Байбол”</span>
        </div>
        <div className="where__pay__link">
            <ul className="where__pay__ul">
                <li><span>Без комиссии</span></li>
                <li><span>Моментальное зачисление платежа</span></li>
            </ul>
        </div>
        <div className="where__pay__link">
            <a href={LINKS.MOBILE_APP} target="_blank" rel="noopener noreferrer nofollow">В Мобильном приложении Байбол Онлайн</a>
            <div className="where__pay__instruction__lang">
                <span>Видео инструкция. Выберите язык:</span>
                <a href={LINKS.CHOOSE_LANG.RU} data-fancybox rel="noopener noreferrer nofollow">Ru</a>
                <a href={LINKS.CHOOSE_LANG.UZ} target="_blank" rel="noopener noreferrer nofollow">Uz</a>
                <a href={LINKS.CHOOSE_LANG.KG} target="_blank" rel="noopener noreferrer nofollow">Kg</a>
                <a href={LINKS.CHOOSE_LANG.TJ} target="_blank" rel="noopener noreferrer nofollow">Tj</a>
            </div>
        </div>
        <div className="where__pay__buttons">
            <div className="where__pay__button">
                <a id={ID_TEST_A_RUSTORE} href={LINKS.APPS.RUSTORE} target="_blank" rel="noopener noreferrer nofollow">
                    <img src={ruStoreLogo} alt='Скачать из RuStore'></img>
                </a>
            </div>
            <div className="where__pay__button">
                <a id={ID_TEST_A_GOOGLE} href={LINKS.APPS.GOOGLE} target="_blank" rel="noopener noreferrer nofollow">
                    <img src={googleLogo} alt='Скачать из Google Play'></img>
                </a>
            </div>
            <div className="where__pay__button">
                <a id={ID_TEST_A_APK} href={LINKS.APPS.APK} target="_blank" rel="noopener noreferrer nofollow">
                    <div className="where__pay__button-apk_imgs">
                        <img className="where__pay__button-apk_img" src={apkLogo} alt='Скачать .apk'></img>
                        <img className="where__pay__button-apk_img" src={apkText} alt='Скачать .apk'></img>
                    </div>
                </a>
            </div>
        </div>
    </div>
);

export default BaibolItem;